<div *ngIf="!configMode" class="non-config-mode-container">
    <azavista3-apexcharts-wrapper
        *ngIf="definition.data"
        #displayModeChart
        [series]="series"
        [labels]="labels"
        [type]="chart.type"
        [width]="chart.width"
        [height]="chart.height"
    >
    </azavista3-apexcharts-wrapper>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <mat-form-field>
                <mat-select (selectionChange)="chartTypeChanged($event.value)"
                            [(value)]="definition.settings.local.chartType"
                            placeholder="{{'CHART_TYPE' | translate}}">
                    <mat-option value='bar'>Bar</mat-option>
                    <mat-option value='donut'>Donut</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="setting-item">
            <mat-form-field *ngIf="enumTypeGlobalEventFields">
                <mat-select (selectionChange)="onSettingsChanged()" [(value)]="definition.settings.remote.field_name"
                            placeholder="{{'GROUP_BY' | translate}}">
                    <mat-option *ngFor="let field of enumTypeGlobalEventFields" [value]="field.id">
                        {{field.label}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="setting-item">
            <azavista-flat-button *ngIf="enumTypeGlobalEventFields" (click)="onShowFilter()"><span translate>FILTER</span></azavista-flat-button>
        </div>
    </div>
    <div class="preview-container">
        <azavista3-apexcharts-wrapper
            *ngIf="definition.data"
            [series]="series"
            [labels]="labels"
            [type]="chart.type"
            [width]="chart.width"
            [height]="chart.height"
            #configModeChart>
        </azavista3-apexcharts-wrapper>
    </div>
</div>
